import { createContext } from "react"

export type DarkModeContextValue = boolean

type ContextType = DarkModeContextValue

export const DarkModeContext = createContext<ContextType>(false)
